import React from "react";

const GRAD_ID = "osp-mark-grad";

export function LogoMark({ size = 36, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="O Seu Precificador" data-testid="logo-mark">
      <defs>
        <linearGradient id={GRAD_ID} x1="8" y1="6" x2="56" y2="58" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#4F46E5" />
          <stop offset="0.55" stopColor="#1E1B4B" />
          <stop offset="1" stopColor="#C5A059" />
        </linearGradient>
      </defs>
      <path d="M32 4.5c7 4.6 14.4 6.5 22 6.2v21.6c0 12.8-8.4 22.4-22 27.2C18.4 54.7 10 45.1 10 32.3V10.7c7.6.3 15-1.6 22-6.2Z" stroke={`url(#${GRAD_ID})`} strokeWidth="4.5" strokeLinejoin="round" fill="#fff" />
      <rect x="21" y="18" width="22" height="28" rx="3.5" fill="#1E1B4B" />
      <rect x="24" y="21" width="16" height="6" rx="1.5" fill="#fff" />
      <rect x="24" y="30" width="4.5" height="4.5" rx="1" fill="#fff" />
      <rect x="29.75" y="30" width="4.5" height="4.5" rx="1" fill="#fff" />
      <rect x="24" y="36.5" width="4.5" height="4.5" rx="1" fill="#fff" />
      <rect x="29.75" y="36.5" width="4.5" height="4.5" rx="1" fill="#fff" />
      <rect x="35.5" y="30" width="4.5" height="11" rx="1.2" fill="#C5A059" />
      <text x="37.75" y="38.6" textAnchor="middle" fontFamily="Arial, Helvetica, sans-serif" fontSize="7.5" fontWeight="700" fill="#1E1B4B">$</text>
    </svg>
  );
}

export function Logo({ size = 36, dark = false, tagline = false, className = "" }) {
  const main = dark ? "text-white" : "text-slate-900";
  const light = dark ? "text-indigo-200" : "text-indigo-600";
  const scale = size / 36;
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="logo">
      <LogoMark size={size} />
      <div className="leading-none">
        <div className="font-heading flex items-baseline gap-1.5" style={{ fontSize: `${1.15 * scale}rem` }}>
          <span className={`font-semibold ${light}`}>Seu</span>
          <span className={`font-extrabold tracking-tight ${main}`}>Precificador</span>
        </div>
        {tagline && (
          <div className="mt-1.5 flex items-center gap-2">
            <span className="h-0.5 w-6 rounded-full bg-[#C5A059]" />
            <span className={`text-xs ${dark ? "text-slate-300" : "text-slate-500"}`}>O preço certo para a sua clínica.</span>
          </div>
        )}
      </div>
    </div>
  );
}
